function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("line", {
  x1: 99.7461,
  y1: 90.5107,
  x2: 99.7461,
  y2: 130.348,
  stroke: "#4035C2",
  strokeWidth: 9
});

var _ref3 =
/*#__PURE__*/
React.createElement("line", {
  x1: 117.116,
  y1: 90.5107,
  x2: 117.116,
  y2: 130.348,
  stroke: "#4035C2",
  strokeWidth: 9
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M70.6621 62.9484L47.0083 47.493",
  stroke: "#4035C2",
  strokeWidth: 9
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M144.73 62.9484L168.07 46.5613",
  stroke: "#4035C2",
  strokeWidth: 9
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M69.5039 130.348H104.362C104.362 120.722 96.5584 112.919 86.9327 112.919C77.307 112.919 69.5039 120.722 69.5039 130.348Z",
  fill: "url(#paint0_linear)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M112.617 130.348H147.475C147.475 120.722 139.672 112.919 130.046 112.919C120.42 112.919 112.617 120.722 112.617 130.348Z",
  fill: "url(#paint1_linear)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 43.6168,
  cy: 43.689,
  r: 8.71441,
  fill: "url(#paint2_linear)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 171.775,
  cy: 41.8271,
  r: 8.71441,
  fill: "url(#paint3_linear)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M145.789 11.7203L128.009 0.565861C125.544 -0.974804 122.359 0.812368 122.359 3.73347V23.0473C122.359 24.3414 123.018 25.537 124.104 26.2149L134.94 33.0184L139.272 35.73C141.64 37.2214 140.603 40.9066 137.808 40.9066H126.044C124.006 40.9066 122.347 42.5829 122.347 44.6412V64.3371C122.347 72.9771 114.988 79.904 106.275 79.0782C98.6846 78.351 93.0345 71.609 93.0345 63.9057V48.08V40.9313V14.8879C93.0345 13.5937 92.3756 12.3982 91.2895 11.7203L73.5094 0.565861C71.0444 -0.974804 67.8594 0.812367 67.8594 3.74579V23.0596C67.8594 24.3537 68.5183 25.5493 69.6044 26.2272L80.4409 33.0308L84.773 35.7423C87.1404 37.2337 86.1031 40.919 83.3086 40.919H71.5569C69.519 40.9313 67.8594 42.5952 67.8594 44.6659V63.4743C67.8594 85.3641 84.8218 103.901 106.495 104.555C129.01 105.233 147.534 86.9294 147.534 64.3371V40.9313V14.8879C147.534 13.6061 146.875 12.3982 145.789 11.7203Z",
  fill: "url(#paint4_linear)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("circle", {
  r: 7.19527,
  transform: "matrix(-1 0 0 1 163.804 123.173)",
  fill: "#FBB54C"
});

var _ref12 =
/*#__PURE__*/
React.createElement("circle", {
  r: 7.19527,
  transform: "matrix(-1 0 0 1 196.902 114.538)",
  fill: "#5BD8FF"
});

var _ref13 =
/*#__PURE__*/
React.createElement("circle", {
  r: 5.03669,
  transform: "matrix(-1 0 0 1 210.575 125.331)",
  fill: "#40ED9A"
});

var _ref14 =
/*#__PURE__*/
React.createElement("circle", {
  r: 5.75622,
  transform: "matrix(-1 0 0 1 181.075 124.612)",
  fill: "#EC6969"
});

var _ref15 =
/*#__PURE__*/
React.createElement("circle", {
  r: 5.73953,
  transform: "matrix(-1 0 0 1 159.659 79.8956)",
  fill: "#EC6969"
});

var _ref16 =
/*#__PURE__*/
React.createElement("circle", {
  r: 7.19527,
  transform: "matrix(-1 0 0 1 150.854 108.782)",
  fill: "#40ED9A"
});

var _ref17 =
/*#__PURE__*/
React.createElement("circle", {
  r: 2.15858,
  transform: "matrix(-1 0 0 1 151.574 121.014)",
  fill: "#EC6969"
});

var _ref18 =
/*#__PURE__*/
React.createElement("circle", {
  r: 2.15858,
  transform: "matrix(-1 0 0 1 194.745 128.209)",
  fill: "#FBB54C"
});

var _ref19 =
/*#__PURE__*/
React.createElement("circle", {
  r: 12.9515,
  transform: "matrix(-1 0 0 1 173.88 103.026)",
  fill: "#5E86EC"
});

var _ref20 =
/*#__PURE__*/
React.createElement("circle", {
  r: 10.0734,
  transform: "matrix(-1 0 0 1 65.1229 105.904)",
  fill: "#EC6969"
});

var _ref21 =
/*#__PURE__*/
React.createElement("circle", {
  r: 9.35386,
  transform: "matrix(-1 0 0 1 42.817 121.014)",
  fill: "#FBB54C"
});

var _ref22 =
/*#__PURE__*/
React.createElement("circle", {
  r: 7.19527,
  transform: "matrix(-1 0 0 1 21.9512 111.66)",
  fill: "#40ED9A"
});

var _ref23 =
/*#__PURE__*/
React.createElement("circle", {
  r: 6.47575,
  transform: "matrix(-1 0 0 1 6.83968 123.892)",
  fill: "#5E86EC"
});

var _ref24 =
/*#__PURE__*/
React.createElement("circle", {
  r: 11.5124,
  transform: "matrix(-1 0 0 1 40.6585 97.2694)",
  fill: "#5BD8FF"
});

var _ref25 =
/*#__PURE__*/
React.createElement("circle", {
  r: 5.03669,
  transform: "matrix(-1 0 0 1 9.72796 86.0802)",
  fill: "#5BD8FF"
});

var _ref26 =
/*#__PURE__*/
React.createElement("circle", {
  r: 3.59764,
  transform: "matrix(-1 0 0 1 25.5488 126.77)",
  fill: "#5E86EC"
});

var _ref27 =
/*#__PURE__*/
React.createElement("circle", {
  r: 2.87811,
  transform: "matrix(-1 0 0 1 59.367 123.173)",
  fill: "#5BD8FF"
});

var _ref28 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 77.4119,
  y1: 136.248,
  x2: 87.7632,
  y2: 104.319,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#442BE0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B377FF"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 120.525,
  y1: 136.248,
  x2: 130.876,
  y2: 104.319,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#442BE0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B377FF"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 38.8563,
  y1: 58.3037,
  x2: 54.9633,
  y2: 33.4624,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#442BE0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B377FF"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 167.015,
  y1: 56.4419,
  x2: 183.121,
  y2: 31.6005,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#442BE0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B377FF"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 85.9348,
  y1: 139.975,
  x2: 190.427,
  y2: 17.1896,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#442BE0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B377FF"
})));

var SvgHumanULogoWithCircles = function SvgHumanULogoWithCircles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 216,
    height: 131,
    viewBox: "0 0 216 131",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHumanULogoWithCircles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/humanULogoWithCircles.0fa9e4b1.svg";
export { ForwardRef as ReactComponent };